import React from "react";
import { Plus, Upload } from "lucide-react";

function AskDoubt() {
  return (
    <div className="min-h-screen bg-[#F4EFE8] p-4 md:p-8">
      {/* MAIN CONTAINER */}
      <div className="max-w-[1450px] mx-auto">

        {/* TOP CHAT BOX */}
        <div className="bg-[#EAE3E7] rounded-md p-4 md:p-8 min-h-[320px] md:min-h-[420px] flex flex-col justify-between">

          {/* BOT MESSAGE */}
          <div className="flex justify-end">
            <div className="max-w-[500px]">
              <h2 className="text-[#6B52C8] text-[28px] md:text-[34px] leading-[45px] font-normal">
                Hi! I am here to help you find answers to your queries.
                How can I help you today?
              </h2>
            </div>
          </div>

          {/* SEARCH INPUT */}
          <div className="mt-10">
            <div className="bg-white border border-[#D7D1D1] rounded-md h-[90px] flex items-center px-5 shadow-sm">

              {/* PLUS ICON */}
              <button className="min-w-[60px] h-[60px] rounded-full border-[5px] border-[#202020] flex items-center justify-center">
                <Plus
                  size={38}
                  strokeWidth={3}
                  className="text-[#202020]"
                />
              </button>

              {/* INPUT */}
              <input
                type="text"
                placeholder="ask your query here..our bot will help you find answers to your queries.."
                className="flex-1 bg-transparent outline-none text-[22px] md:text-[26px] text-[#BEBEBE] px-6"
              />
            </div>
          </div>
        </div>

        {/* POST QUERY SECTION */}
        <div className="mt-16">

          {/* TITLE */}
          <h2 className="text-[#6B52C8] text-[34px] md:text-[44px] font-semibold mb-5">
            Post your query/ doubt
          </h2>

          {/* QUERY BOX */}
          <div className="bg-white border border-[#D7D1D1] rounded-md min-h-[160px] md:min-h-[190px] flex items-center justify-between px-6 md:px-8 shadow-sm">

            {/* TEXTAREA */}
            <textarea
              placeholder="type here.. or upload image of your query"
              className="flex-1 resize-none bg-transparent outline-none text-[24px] md:text-[34px] text-[#C8C8C8] h-full pt-10"
            />

            {/* UPLOAD */}
            <label className="cursor-pointer ml-5">
              <Upload
                size={46}
                strokeWidth={2.2}
                className="text-[#202020]"
              />

              <input
                type="file"
                className="hidden"
              />
            </label>
          </div>
        </div>
      </div>

      {/* PAST QUERIES SECTION */}
<div className="mt-20">

  {/* TITLE */}
  <h2 className="text-[#6B52C8] text-[28px] md:text-[38px] font-semibold mb-8">
    Past queries
  </h2>

  {/* TABLE HEADER */}
  <div className="grid grid-cols-[120px_1fr] md:grid-cols-[180px_1fr] gap-5 mb-4">

    <h3 className="text-[22px] md:text-[30px] font-medium text-black">
      Posted on
    </h3>

    <h3 className="text-[22px] md:text-[30px] font-medium text-black">
      My Query/ Doubt
    </h3>

  </div>

  {/* QUERY LIST */}
  <div className="space-y-8">

    {[1, 2].map((item) => (

      <div key={item}>

        <div className="grid grid-cols-[120px_1fr] md:grid-cols-[180px_1fr] gap-5">

          {/* DATE */}
          <div className="bg-white border border-[#D7D1D1] rounded-md h-[90px]"></div>

          {/* QUERY */}
          <div className="bg-white border border-[#D7D1D1] rounded-md h-[90px] flex items-center justify-between px-6">

            <p className="text-[#222] text-[18px] md:text-[24px]">
              Unable to understand algebraic equations
            </p>

            <button>
              <svg
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M6 9L12 15L18 9"
                  stroke="#202020"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>

          </div>

        </div>

        {/* VIEW RESPONSES */}
        <button className="mt-3 ml-[140px] md:ml-[205px] text-[18px] md:text-[22px] underline text-[#202020]">
          + view responses
        </button>

      </div>

    ))}

  </div>

  {/* VIEW MORE */}
  <button className="mt-12 text-[22px] md:text-[30px] underline text-[#202020]">
    + view more
  </button>

  {/* FOOTER */}
  <div className="mt-24 text-center text-[#202020] text-[18px] md:text-[22px]">

    <p>
      Copyright © 2026
      <span className="mx-4 underline cursor-pointer">
        Terms of Use
      </span>

      <span className="underline cursor-pointer">
        Privacy Policy
      </span>
    </p>

  </div>

</div>
    </div>
  );
}

export default AskDoubt;